export default "__VITE_ASSET__BuA8LbNN__"